import ProductItemCard from "./productItemCard.jsx";

const ProductGrid = ({ data, onOpenDetails }) => {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 p-4 bg-white border-x-2 border-b-2 rounded-b-xl shadow-sm min-h-[400px] content-start">
            {data.map((product) => (
                <ProductItemCard 
                    key={product.product_id} 
                    item={product} 
                    onClick={onOpenDetails} 
                />
            ))}
        </div>
    );
};

export default ProductGrid;